import React from "react";
import styled from "styled-components";
import PlusSpectral from "../../assets/plus-spectral.svg";
import { useDialogStepsContext } from "../../contexts/DialogStepsContext";
import Flex from "../Flex";

interface AddMoreWalletsProps {
  flat?: boolean;
}

const AddMoreLabelBorders = styled.div`
  width: auto;
  height: 46px;
  border-radius: 26px;
  display: flex;
  padding: 0 15px;
  border: 1px solid var(--gray-10);
  margin: 30px 0;
  cursor: pointer;
`;

const AddMoreWalletsFlat = styled.div`
  cursor: pointer;
`;

const AddMoreWalletsLabel = styled.span`
  font-size: var(--fs14);
  margin: 25px 0;
`;

export const AddMoreWallets = ({ flat }: AddMoreWalletsProps) => {
  const { addNewWallet } = useDialogStepsContext();

  if (flat) {
    return (
      <AddMoreWalletsFlat onClick={addNewWallet}>
        <Flex width="158px" align="center" justify="around">
          <img src={PlusSpectral} alt="Add more wallets" />
          <AddMoreWalletsLabel>Add more wallets</AddMoreWalletsLabel>
        </Flex>
      </AddMoreWalletsFlat>
    );
  }
  return (
    <AddMoreLabelBorders onClick={addNewWallet}>
      <Flex width="158px" align="center" justify="around">
        <img src={PlusSpectral} alt="Add more wallets" />
        <AddMoreWalletsLabel>Add more wallets</AddMoreWalletsLabel>
      </Flex>
    </AddMoreLabelBorders>
  );
};
